module.exports = __webpack_public_path__ + "img/10.9c1c87a0.jpg";